import { render, staticRenderFns } from "./TableButtonGroup.vue?vue&type=template&id=2b231dd0"
import script from "./TableButtonGroup.vue?vue&type=script&lang=js"
export * from "./TableButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports